import BCDice_ from './BCDice';

export { default as DiceBot } from './DiceBot';
export { default as DiceBotLoader } from './DiceBotLoader';
export { default as DiceBotLoaderList } from './DiceBotLoaderList';
export { default as DiceBotResolver } from './DiceBotResolver';

export const BCDice = BCDice_;
export default BCDice;
